const hulkLoad = setInterval(function(){
    if (document.readyState === 'complete' && hulkapps || typeof hulkapps === 'undefined'){
      clearInterval(hulkLoad);
      console.log('HulkPO Loaded');
      document.querySelector('.btn-hulk-submit').removeAttribute('disabled');
      document.querySelector('.btn-hulk-submit').classList.remove('btn-hulk-submit');
    }
},100)

$(document).ready(function () {
	
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('preview_key')) {
        $(document).find('.qmp_button_container.qmp_button_container_').addClass('d-none');
    }

    if($('.product-form .price-block .price-list .price_').length){
        $(document).find('.qmp_button_container.qmp_button_container_').addClass('d-none');
    }

});